import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18e5adc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "download-container" }
const _hoisted_2 = { class: "download-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "download-title" }, "Choose Export Format", -1))
const _hoisted_4 = { class: "download-subtitle" }
const _hoisted_5 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "spinner" })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "loading-text" }, "Preparing your download...", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "download-options"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "option-icon pdf-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-pdf" })
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "option-content" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "PDF Format"),
  /*#__PURE__*/_createElementVNode("p", null, "Best for submitting applications")
], -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "option-icon word-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-word" })
], -1))
const _hoisted_14 = { class: "option-content" }
const _hoisted_15 = {
  key: 0,
  class: "premium-badge"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-gem me-1" }, null, -1))
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "download-option disabled" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "option-icon txt-icon" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-text" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "option-content" }, [
    /*#__PURE__*/_createElementVNode("h5", null, "Plain Text"),
    /*#__PURE__*/_createElementVNode("p", null, "Coming soon"),
    /*#__PURE__*/_createElementVNode("span", { class: "coming-soon-badge" }, "Soon")
  ])
], -1))
const _hoisted_20 = {
  key: 0,
  class: "modal fade show d-block",
  tabindex: "-1",
  style: {"background":"rgba(0, 0, 0, 0.5)","overflow-y":"auto","height":"100vh"}
}

import { ref, computed } from "vue";
import { toast } from "vue3-toastify";
import Modal from "./Modal.vue";
import Subscribe from "../views/Subscribe.vue";
import { DocumentApiService } from "../services/DocumentApiService";
import { ResumeGeneratorService } from "../services/ResumeGeneratorService";
import { FileApiService } from "../services/FilesApiService";
import { ResponseDto } from "../../../server/src/models/dtos/ResponseDtos";
import { TemplateOptions } from "../../../server/src/models/dtos/ResponseDtos";
import { ResponseType } from "../../../server/src/models/Response";
import { Tone } from "../../../server/src/models/SystemEnums";
import { SubscriptionPlan } from "../../../server/src/models/SystemEnums";
import type { Resume } from "../../../server/src/models/Resume";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'DownloadModal',
  props: {
    resumeId: {},
    resume: {},
    documentId: {},
    documentType: {}
  },
  setup(__props: any, { expose: __expose }) {

const store = useStore();
const modal = ref<InstanceType<typeof Modal> | null>(null);
const loading = ref(false);
const showSubscribeModal = ref(false);

// Props
const props = __props;

// Check if user has premium subscription
const isPremiumUser = computed(() => {
  const user = store.state.user.user;
  return user && user.subscriptionPlan !== SubscriptionPlan.BASIC && user.subscriptionPlan !== "";
});

// Shared function to get resume data if not provided
async function getResumeData() {
  if (props.resume) return props.resume;
  if (!props.resumeId && props.documentType !== "coverLetter")
    throw new Error("No resume ID provided");

  if (props.documentType === "coverLetter") {
    return null; // No need to fetch resume data for cover letter
  }

  const response = await DocumentApiService.getUserResume(props.resumeId as string);
  if (response.status !== 200 || !response.data) {
    throw new Error("Failed to fetch resume data");
  }
  return response.data;
}

// Shared function to trigger file download
function triggerFileDownload(blob: Blob, filename: string) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
  modal.value?.hide();
}

async function downloadAsPdf() {
  loading.value = true;
  try {
    if (props.documentType === "coverLetter") {
      if (!props.documentId) {
        throw new Error("No document ID provided");
      }

      // Get the actual PDF buffer from the API
      const response = await FileApiService.getFileById(props.documentId, true);

      if (response.status !== 200) {
        throw new Error("Failed to fetch the file data.");
      }

      // Create blob from the actual buffer data
      const blob = new Blob([response.data], { type: "application/pdf" });
      triggerFileDownload(blob, "CoverLetter.pdf");

      toast.success("PDF downloaded successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
      return;
    }

    const resume = await getResumeData();
    if (!resume) {
      throw new Error("Failed to get resume data");
    }

    const template = resume.template || TemplateOptions.RESUME_CLASSIC;

    const result = await FileApiService.getPDFPreview(
      new ResponseDto(
        null,
        "",
        "",
        resume.userId,
        false,
        ResponseType.CreateResume,
        null,
        0.7,
        Tone.FORMAL,
        template,
        "",
        resume as unknown as Record<string, unknown>,
        null,
        null
      )
    );

    if (result.status !== 200) {
      throw new Error("Failed to generate PDF");
    }

    const blob = new Blob([result.data], { type: "application/pdf" });
    triggerFileDownload(blob, `${resume.name || "Resume"}.pdf`);

    toast.success("PDF downloaded successfully!", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 3000,
    });
  } catch (error) {
    console.error("Error downloading PDF:", error);
    toast.error("Failed to download PDF. Please try again.", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 3000,
    });
  } finally {
    loading.value = false;
  }
}

// Handle Word document download based on premium status
function handleWordDownload() {
  if (!isPremiumUser.value) {
    showUpgradeModal();
    return;
  }

  downloadAsWord();
}

// Show the upgrade modal
function showUpgradeModal() {
  modal.value?.hide();
  showSubscribeModal.value = true;
  document.body.style.overflow = "hidden"; // Prevent scrolling when modal is open
}

// Close the subscription modal
function closeSubscribeModal() {
  showSubscribeModal.value = false;
  document.body.style.overflow = ""; // Re-enable scrolling
}

async function downloadAsWord() {
  loading.value = true;
  try {
    if (props.documentType === "coverLetter") {
      if (!props.documentId) {
        throw new Error("No document ID provided");
      }

      const result = await FileApiService.getFileById(props.documentId, false);
      if (result.status != 200) {
        throw new Error("There has been a problem downloading this document");
      }

      const blob = new Blob([result.data], {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });
      triggerFileDownload(blob, "CoverLetter.docx");

      toast.success("Word document downloaded successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
      return;
    }

    const resume = await getResumeData();
    if (!resume) {
      throw new Error("Failed to get resume data");
    }

    const template = resume.template || TemplateOptions.RESUME_CLASSIC;

    const result = await ResumeGeneratorService.generateWordDocument(resume, template);
    if (result.status !== 200 || !result.data?.fileId) {
      throw new Error("Failed to generate document");
    }

    const wordDocResult = await ResumeGeneratorService.downloadWordDocument(result.data.fileId);
    if (wordDocResult.status !== 200) {
      throw new Error("Failed to download document");
    }

    const blob = new Blob([wordDocResult.data], {
      type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    });
    triggerFileDownload(blob, `${resume.name || "Resume"}.docx`);

    toast.success("Word document downloaded successfully!", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 3000,
    });
  } catch (error) {
    console.error("Error downloading Word document:", error);
    toast.error("Failed to download Word document. Please try again.", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 3000,
    });
  } finally {
    loading.value = false;
  }
}

// Expose methods to parent
__expose({
  show: () => modal.value?.show(),
  hide: () => modal.value?.hide(),
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Modal, {
      ref_key: "modal",
      ref: modal,
      hideFooter: ""
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("p", _hoisted_4, " Download your " + _toDisplayString(_ctx.documentType === "resume" ? "resume" : "cover letter") + " in your preferred format ", 1)
          ]),
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", {
                  class: "download-option",
                  onClick: downloadAsPdf
                }, _hoisted_12),
                _createElementVNode("div", {
                  class: _normalizeClass(["download-option", { 'premium-option': !isPremiumUser.value }]),
                  onClick: handleWordDownload
                }, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("h5", null, [
                      _createTextVNode(" Word Document "),
                      (!isPremiumUser.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                            _hoisted_16,
                            _createTextVNode("Premium")
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (isPremiumUser.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_17, "Editable in Microsoft Word"))
                      : (_openBlock(), _createElementBlock("p", _hoisted_18, "Edit, customize, and tailor your document"))
                  ])
                ], 2),
                _hoisted_19
              ]))
        ])
      ]),
      _: 1
    }, 512),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (showSubscribeModal.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createVNode(Subscribe, {
              "is-modal": true,
              onClose: closeSubscribeModal
            }),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close position-absolute top-0 end-0 m-4",
              onClick: closeSubscribeModal,
              style: {"z-index":"1050"}
            })
          ]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})